






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RichTextObject extends Vue {
    @Prop({required:true})
    data: any;

    htmlcontent: string | null = null;

    // Body content is stored as plain HTML in src/content/site.json.
    mounted(){ 
        this.htmlcontent = this.data;
    }
}
